import type { BoxProps } from '@interstate/components/Box';

export const recentDealsButtonStyles: BoxProps['sx'] = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '24px',
    height: '24px',
    border: '1px solid #005BA8',
    borderRadius: '4px',
    cursor: 'pointer',
    '& svg': {
        color: '#005BA8'
    }
};
